import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";

import CircularProgress from "@material-ui/core/CircularProgress";

import { Auth } from "aws-amplify";
import * as authActions from "../redux/actions/authActions";

export default function Loading(MainComponent) {
  function AuthenticatedComponent(props) {
    useEffect(() => {
      checkAuthentication();
    }, []);

    const [authenticated, setauthenticated] = useState(false);

    const checkAuthentication = async () => {
      try {
        await getUserDetails(false);
      } catch (error) {
        console.log(error);
        try {
          await getUserDetails(true);
        } catch (e) {
          console.log(e);
          props.history.push("/");
        }
      }
    };

    const getUserDetails = async bypassCache => {
      const { dispatch } = props;
      Auth.currentAuthenticatedUser({
        bypassCache: bypassCache // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      })
        .then(async user => {
          // console.log(user);
          dispatch(authActions.setUser(user.attributes));
          if (!user.attributes.email_verified) props.history.push("/verify-email");
          else if (!MainComponent) {
            props.history.replace("/home");
          } else setauthenticated(true);
        })
        .catch(err => {
          console.log("here", err);
          props.history.push("/login");
        });
    };

    if (authenticated) {
      return <MainComponent {...props} />;
    } else return null;
    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  return connect(null)(AuthenticatedComponent);
}
